import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-mb-md" };
const _hoisted_2 = { class: "dialog-body" };
const _hoisted_3 = { class: "q-mt-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_dialog = _resolveComponent("q-dialog");
    return (_openBlock(), _createBlock(_component_q_dialog, { "model-value": _ctx.show }, {
        default: _withCtx(() => [
            _createVNode(_component_q_card, {
                class: "dialog",
                style: { "white-space": "pre-line" }
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.commonStore.messages.PE0029), 1),
                            _createVNode(_component_q_card, { class: "q-pa-sm" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenants, (tenant) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: tenant.orgNyukyokeiyakuNo,
                                                class: "q-px-md q-py-sm"
                                            }, [
                                                _createVNode(_component_q_icon, {
                                                    size: "sm",
                                                    name: tenant.roomSb === _ctx.RoomSb.Parking ? 'directions_car' : 'maps_home_work',
                                                    color: "grey-7"
                                                }, null, 8, ["name"]),
                                                _createTextVNode(" " + _toDisplayString(tenant.bukkenName) + " " + _toDisplayString(tenant.roomNumber) + "（" + _toDisplayString(tenant.nyukyosha) + "） ", 1)
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.commonStore.messages.PE0030), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "right" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                                class: "ok-button",
                                flat: "",
                                label: "OK",
                                onClick: _ctx.close
                            }, null, 8, ["onClick"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["model-value"]));
}
